import { newToolFilterOAuthMcp } from "../oauth.ts";

export const tldvMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://tldv.io/faviconV2.png",
  url: "https://mcp.tldv.io/mcp",
  label: "tl;dv",
});
